import request from '@/utils/request'

/**
 * @param {Object} data
 */
// 系统配置
export function system_setting_api(data) {
    return request({
        url: '/setting/index',
        method: 'get',
        data,
    })
}
// VIP
export function index_notice_list_api(data) {
    return request({
        url: '/index/notice_list',
        method: 'post',
        data
    })
}
// 公告详情
export function index_notice_details_api(data) {
    return request({
        url: '/index/notice_details',
        method: 'post',
        data
    })
}
// banner
export function index_banner_api() {
    return request({
        url: '/setting/banner',
        method: 'get'
    })
}

// 用户信息
export function user_info_api(data) {
    return request({
        url: '/user/info',
        method: 'get',
        data
    })
}

// 商品
export function index_goods_list_api(data) {
    return request({
        url: '/goods/list',
        method: 'post',
        data
    })
}
// 商品评价
export function goods_evaluate_api(data) {
    return request({
        url: '/goods/evaluate',
        method: 'post',
        data
    })
}
// 分类列表
export function index_goods_type_api(data) {
    return request({
        url: '/goods/type',
        method: 'post',
        data
    })
}
// 商品详情
export function index_goods_detail_api(data) {
    return request({
        url: '/goods/detail',
        method: 'post',
        data
    })
}
// 收藏
export function user_set_favorites_api(data) {
    return request({
        url: '/user/set_favorites',
        method: 'post',
        data
    })
}
// 购物车
export function goods_addCart_api(data) {
    return request({
        url: '/goods/addCart',
        method: 'post',
        data
    })
}
export function goods_cartList_api(data) {
    return request({
        url: '/goods/cartList',
        method: 'get',
        data
    })
}
